import { createContext } from 'react';

const TRulesContext = createContext(null);

export { TRulesContext };
